import { render, staticRenderFns } from "./IncreaseInsurableRisk.vue?vue&type=template&id=8da38366&scoped=true&"
import script from "./IncreaseInsurableRisk.vue?vue&type=script&lang=js&"
export * from "./IncreaseInsurableRisk.vue?vue&type=script&lang=js&"
import style0 from "./IncreaseInsurableRisk.vue?vue&type=style&index=0&id=8da38366&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da38366",
  null
  
)

export default component.exports